/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreatePromptRequest interface.
 */
export function instanceOfCreatePromptRequest(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
export function CreatePromptRequestFromJSON(json) {
    return CreatePromptRequestFromJSONTyped(json, false);
}
export function CreatePromptRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'description': json['description'] == null ? undefined : json['description'],
        'minTrafficShare': json['minTrafficShare'] == null ? undefined : json['minTrafficShare'],
        'name': json['name'],
        'systemPrompt': json['systemPrompt'] == null ? undefined : json['systemPrompt'],
        'type': json['type'],
        'userPromptTemplate': json['userPromptTemplate'] == null ? undefined : json['userPromptTemplate'],
    };
}
export function CreatePromptRequestToJSON(json) {
    return CreatePromptRequestToJSONTyped(json, false);
}
export function CreatePromptRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'description': value['description'],
        'minTrafficShare': value['minTrafficShare'],
        'name': value['name'],
        'systemPrompt': value['systemPrompt'],
        'type': value['type'],
        'userPromptTemplate': value['userPromptTemplate'],
    };
}
